<tax-input
  [tabindex]="0"
  [formControl]="searchInput"
  placeholder="retail.place.placeholder"
  [autofocus]="true"
  [clearable]="true"
  data-qa-input="search"
>
</tax-input>

<div class="ui-kit-tag-list" data-qa-block="tag-list">
  <div
    *ngFor="let status of subscriptionsTags | keyvalue: objectInOriginalOrder"
    class="ui-kit-tag"
    [class.tag__selected]="status.value.selected"
    (click)="selectTag($any(status))"
    [attr.data-qa-tag]="status.value.name"
  >
    <span data-qa="tag-name">{{ status.value.name | translate }}</span>
    <span data-qa="tag-counter" class="ui-kit-tag__counter">{{ status.value.count }}</span>
  </div>
</div>
